import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English' },
];

export const LANGUAGE_STORAGE_KEY = 'bmcl_language';

// Default language per role.
export const defaultLanguageForRole = () => 'en';

// Resolve the language to use: an explicit user choice wins, otherwise
// fall back to English.
export const resolveInitialLanguage = (role) => {
  const stored = typeof window !== 'undefined' ? localStorage.getItem(LANGUAGE_STORAGE_KEY) : null;
  if (stored && SUPPORTED_LANGUAGES.some((l) => l.code === stored)) return stored;
  return defaultLanguageForRole(role);
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export const changeLanguage = (lng) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
  }
  return i18n.changeLanguage(lng);
};

export default i18n;
